import { ReactNode } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from '@mui/material'

type ConfirmationModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  confirmText?: string
  cancelText?: string
  confirmStartIcon?: ReactNode
  cancelStartIcon?: ReactNode
  confirmColor?:
    'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'
  isDisabled?: boolean
  isSubmitting?: boolean
  children?: ReactNode
}

export default function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmColor = 'primary',
  confirmStartIcon,
  cancelStartIcon,
  isDisabled = false,
  isSubmitting = false,
  children,
}: ConfirmationModalProps) {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            bgcolor: 'background.default',
          },
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      {children && <DialogContent>{children}</DialogContent>}
      <DialogActions className="gap-2 p-6">
        <Button
          onClick={onClose}
          variant="outlined"
          startIcon={cancelStartIcon || null}
          disabled={isDisabled || isSubmitting}
        >
          {cancelText}
        </Button>
        <Button
          color={confirmColor}
          variant="contained"
          onClick={onConfirm}
          disabled={isDisabled || isSubmitting}
          startIcon={
            isSubmitting ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              confirmStartIcon || null
            )
          }
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
